import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "grid gap-5"
}
const _hoisted_2 = {
  key: 1,
  class: "text-[13px] leading-relaxed text-gray-500"
}

import { computed } from 'vue'

import SelectInput from '@/components/neue/SelectInput.vue'

import AgentToggleRow from './AgentToggleRow.vue'


export default {
  __name: 'AgentOfferFields',
  props: {
  enabled: { type: Boolean, default: false },
  discountCodeId: { type: String, default: '' },
  codes: { type: Array, default: () => [] }
},
  emits: ['update:enabled', 'update:discountCodeId'],
  setup(__props, { emit: __emit }) {

const props = __props
const emit = __emit

const codeLabel = ({ attributes }) =>
  attributes.discount_code_name ? `${attributes.discount_code_name} (${attributes.code})` : attributes.code

const options = computed(() => props.codes.map(code => ({ name: codeLabel(code), value: String(code.id) })))

return (_ctx, _cache) => {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AgentToggleRow, {
      "model-value": props.enabled,
      label: "Include an offer",
      help: "Let the agent mention one of your discount codes in the conversation.",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (emit('update:enabled', $event)))
    }, null, 8, ["model-value"]),
    (props.enabled)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (options.value.length)
            ? (_openBlock(), _createBlock(SelectInput, {
                key: 0,
                "model-value": props.discountCodeId,
                name: "Offer",
                options: options.value,
                placeholder: "Choose a discount code",
                description: "The agent states the discount and its code exactly as set up on the discount code.",
                class: "sm:max-w-md",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (emit('update:discountCodeId', $event)))
              }, null, 8, ["model-value", "options"]))
            : (_openBlock(), _createElementBlock("p", _hoisted_2, [
                _cache[3] || (_cache[3] = _createTextVNode(" You have no active discount codes yet. Create a ", -1)),
                _createVNode(_component_router_link, {
                  to: "/store/discount-codes",
                  class: "font-medium text-brand-600 hover:underline"
                }, {
                  default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                    _createTextVNode(" discount code ", -1)
                  ]))]),
                  _: 1
                }),
                _cache[4] || (_cache[4] = _createTextVNode(" first, then pick it here. ", -1))
              ]))
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

}